var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Mail = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 23 16", a11yTitle: "Mail" }, props, { children: _jsx("path", { d: "M3.14961 0.500122C1.7418 0.500122 0.599609 1.64231 0.599609 3.05012V13.2501C0.599609 14.6579 1.7418 15.8001 3.14961 15.8001H20.1496C21.5574 15.8001 22.6996 14.6579 22.6996 13.2501V3.05012C22.6996 1.64231 21.5574 0.500122 20.1496 0.500122H3.14961ZM1.26367 2.91731L11.6496 8.522L22.0355 2.91731L15.448 8.04387L20.8934 13.622L14.2527 8.89387L11.6496 10.5673L9.04648 8.89387L2.40586 13.622L7.85117 8.04387L1.26367 2.91731Z", fill: "#000" }) }))); });
//# sourceMappingURL=Mail.js.map